import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllWallet } from '../../../redux/wallet/action';
import { useNavigate } from 'react-router-dom';
import NormalCardHeader from '../../Common/CardHeader/NormalCardHeader';
import ExportMenu from '../../Common/Export/ExportMenu';
import CommonPagination from "../../Common/Pagination/CommonPagination";



const WalletList = () => {
  const list = useSelector((state) => state.reusableSlice.WalletList);
  const pagination_meta = list?.pagination_meta;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    validity: "",             
    wallet_type: "",     
    per_page: "10",

  });


  useEffect(() => {
    dispatch(getAllWallet(params));
  }, [dispatch, params]);

  const walletEntries = list?.wallet_entries || [];


const handleFilterChange = (e) => {
  const { name, value } = e.target;

  setParams((prev) => ({
    ...prev,
    [name]: value === "" ? "" : parseInt(value, 10),  // Ensures int type
    page: 1,
  }));
};


  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  console.log(list, "list")
  return (
    <div className="card-head order-card">
        <h2 className='pb-2'>Wallet List</h2>
          <NormalCardHeader
        params={params}
        setParams={setParams}
        // addmodel={addComponent}
        // search={search}
        // setOpenFilter={setOpenFilter}
      />
   




        <div className="table-category mt-3 ">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          
          <div className="d-flex justify-content-end align-items-center table-right product-wrap" style={{whiteSpace:"nowrap"}}>
            Filter by
          
             <select
              name="validity"
              value={params.validity}
              onChange={handleFilterChange}
              className="form-control"
            >
              <option value="">All</option>
              <option value="1">Unlimited</option>
              <option value="2">Days</option>
              <option value="3">Weeks</option>
              <option value="4">Months</option>
              <option value="5">Years</option>
            </select>
             <select
              name="additional_type"
              value={params.additional_type}
              onChange={handleFilterChange}
              className="form-control"
            >
              <option value="">All</option>
              <option value="1">Advertising</option>
              <option value="2">Compensation</option>
            </select>
             <select
              name="wallet_type"
              value={params.wallet_type}
              onChange={handleFilterChange}
              className="form-control"
            >
              <option value="">All</option>
              <option value="1">Credit</option>
              <option value="2">Debit</option>
            </select>
            <ExportMenu resource="wallet-transactions" params={params} />
          </div>
        </div>
      <div className="table-sec table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>User</th>
              <th>Reference</th>
              <th>Complain</th>
              <th>Created On</th>
              <th>validity</th>
              <th>Additional Type</th>
              <th>Wallet Type</th>
              <th>Usage Percentage</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {walletEntries.length > 0 ? (
              walletEntries.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.contact}</td>
                  <td>{entry.reference}</td>
                  <td>{entry.complain || "-"}</td>
                  <td>{entry.created_on}</td>
                  <td style={{whiteSpace:"nowrap"}}> {entry.duration_type === 1 ? "Unlimited" : entry.duration_type === 2 ? "Days" : entry.duration_type === 3 ? "Weeks" : entry.duration_type === 4 ? "Months" : entry.duration_type === 5 ? "Years": "-"}</td>
                  <td>{entry.additional_type === 1 ? "Advertising" : entry.additional_type === 2 ? "Compensation" : "-"}</td>
                  <td>{entry.wallet_type === 1 ? "Credit" : entry.wallet_type === 2 ? "Debit" : "-"}</td>
                  <td>{entry.usage_percentage}</td>
                  <td>{entry.amount}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">No wallet entries found.</td>
              </tr>
            )}
          </tbody>
        </table>
         <div className="d-flex justify-content-between align-items-center">
                          <div className="mb-3">
                 <select
                   className="form-select"
                   value={params.per_page || 10}
                   onChange={(e) =>
                     setParams((prev) => ({
                       ...prev,
                       page: 1, // reset to first page when changing per_page
                       per_page: e.target.value,
                     }))
                   }
                   style={{ width: "100px" }}
                 >
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                   <option value="100">100</option>
                 </select>
               </div>
                {pagination_meta && (
                         <CommonPagination
                           currentPage={pagination_meta.current_page}
                           totalPages={pagination_meta.pages}
                           onPageChange={handlePageChange}
                         />
                       )}
                       </div>
      </div>
      </div>
    </div>
  );
};

export default WalletList;
